import { createI18n } from 'vue-i18n'
import zh from './locales/zh.json'
import en from './locales/en.json'

export type Locale = 'zh' | 'en'

export const SUPPORTED_LOCALES: Locale[] = ['zh', 'en']
export const DEFAULT_LOCALE: Locale = 'zh'

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: DEFAULT_LOCALE,
  fallbackLocale: 'en',
  missingWarn: false,
  fallbackWarn: false,
  messages: {
    zh,
    en,
  },
})

export function setI18nLocale(loc: Locale): void {
  i18n.global.locale.value = loc
  document.documentElement.lang = loc === 'zh' ? 'zh-CN' : 'en'
}
